<template>
  <div :class="cssClass">
    <!-- Navigation Tabs -->
    <div>
      <ul class="nav nav-tabs">
        <li v-for="tab in tabs" :key="tab" class="nav-item">
          <!-- Make selected tab to active -->
          <a
            :class="[{ active: tab?.id === selectedTab }, 'nav-link']"
            @click="setSelectedTab(tab)"
          >
            {{ tab?.name }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Content -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "NavTab",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    selectedTab: {
      type: Number,
      default: null,
    },
    cssClass: String,
  },
  data() {
    return {};
  },
  methods: {
    setSelectedTab(tab) {
      this.$emit("selected-tab", tab.id);
    },
  },
  watch: {
    tabs(value) {
      if (this.selectedTab === null) {
        this.$emit("selected-tab", value[0].id);
      }
    },
  },
  created() {
    if (this.selectedTab === null) {
      this.$emit("selected-tab", this.tabs[0]?.id);
    }
  },
};
</script>
